import { useStoreLogger } from '@/logger.ts'

export function SetCacheItem(key: string, value: unknown, expiration: number) {
  const logger = useStoreLogger()
  logger.debug('SetCacheItem', key)
  const expirationTime = new Date().getTime() + expiration * 1000
  localStorage.setItem(key, JSON.stringify(value))
  localStorage.setItem(`${key}_expiration`, expirationTime.toString())
}

export function GetCacheItem<Type>(key: string): Type | null {
  const logger = useStoreLogger()
  logger.debug('GetCacheItem', key)
  const expiration = localStorage.getItem(`${key}_expiration`)
  if (expiration) {
    const expirationTime = parseInt(expiration)
    if (expirationTime > new Date().getTime()) {
      const value = localStorage.getItem(key)
      if (value) {
        logger.debug('GetCacheItem hit', key)
        return JSON.parse(value)
      }
    } else {
      logger.debug('GetCacheItem expire', key)
      localStorage.removeItem(key)
      localStorage.removeItem(`${key}_expiration`)
    }
  }
  return null
}

export async function SetWithExpiry(key: string, value: unknown, cacheSeconds: number) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + (cacheSeconds * 1000), // Convert seconds to milliseconds
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function GetWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export function RemoveCacheItem(key: string) {
  const logger = useStoreLogger()
  logger.debug('RemoveCacheItem', key)
  localStorage.removeItem(key)
  localStorage.removeItem(`${key}_expiration`)
}
